import React from 'react'

import { useQuery } from '@/common/hooks'

import JoinLeadAcceptInvite from './joinLeadAccepInvite'

const JoinLead = _props => {
  const query = useQuery()
  const offer = query.get('promo_code')
  const token = query.get('invite')
  const step = query.get('step')
  const type = query.get('type')

  return <JoinLeadAcceptInvite offer={offer} step={step} token={token} type={type}/>
}

export default JoinLead
